import {
  initializeApp
} from 'firebase/app';
import {
  getAuth
} from 'firebase/auth';
import {
  getDatabase
} from 'firebase/database';

let exportedModule = {};

if (process.env.WHERE == 'standalone') {
  exportedModule = process.env.NODE_ENV === 'production' ? require('./firebase.standalone-prod.js') : require('./firebase.standalone-dev.js');
  // module.exports =  process.env.NODE_ENV === 'production' ? require('./firebase.standalone-prod.js') : require('./firebase.standalone-dev.js');
} else if (process.env.WHERE == 'champions') {
  exportedModule = process.env.NODE_ENV === 'production' ? require('./firebase.champions-prod.js') : require('./firebase.champions-dev.js');
} else if (process.env.WHERE == 'nations') {
  exportedModule = process.env.NODE_ENV === 'production' ? require('./firebase.nations-prod.js') : require('./firebase.nations-dev.js');
} else {
  exportedModule = process.env.NODE_ENV === 'production' ? require('./firebase.seriea-prod.js') : require('./firebase.seriea-dev.js');
}

const firebaseConfig = exportedModule.firebaseConfig
const databaseURL_shared = exportedModule.databaseURL_shared
const databaseURL = exportedModule.databaseURL

let appShared = initializeApp(firebaseConfig, 'appShared')
let authShared = getAuth(appShared)
let databaseShared = getDatabase(appShared, databaseURL_shared)


let auth
let database
let app
if (!databaseURL) {
  auth = appShared
  database = databaseShared
  app = appShared
} else {
  app = initializeApp(firebaseConfig, {
    ...firebaseConfig,
    databaseURL: databaseURL,
  })
  auth = getAuth(app)
  database = getDatabase(app, databaseURL)
}

// console.log('app', app);
// console.log('appShared', appShared);

export {
  app,
  database,
  auth,
  appShared,
  databaseShared,
  authShared
}
